import React, { useMemo } from 'react'
import ImageGallery from 'react-image-gallery'
import 'react-image-gallery/styles/css/image-gallery.css'

const ImageGalleryWrapper = ({
  images,
}) => {

  const items = useMemo(() => {
    return images.map(image => ({
      original: image,
      thumbnail: image,
    }))
  }, [
    images,
  ])
  
  return (
    <ImageGallery items={ items } />
  )
}

export default ImageGalleryWrapper
